import { colorLuminance } from './utils';

export default {
  primary: '#0B244F',
  secondary: '#F2F3F6',
  negative: '#e45b78',
  positive: '#A3D9B1',
  textPrimary: '#333',
  backgroundPrimary: '#0B244F',
  backgroundSecondary: '#E5E5E5',
  backgroundPrimaryLighten: colorLuminance('#0B244F', -0.1),
  backgroundSecondaryLighten: colorLuminance('#E5E5E5', -0.2),
  backgroundHover: '#0B244F',
};
